var React = require('react');

function Calendar (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M76 16H20C15.5817 16 12 19.5817 12 24V80C12 84.4183 15.5817 88 20 88H76C80.4183 88 84 84.4183 84 80V24C84 19.5817 80.4183 16 76 16Z","stroke":"#130A09","strokeWidth":"8","strokeLinecap":"round","strokeLinejoin":"round","key":0}),React.createElement("path",{"d":"M64 8V24M32 8V24M12 40H84","stroke":"#130A09","strokeWidth":"8","strokeLinecap":"round","strokeLinejoin":"round","key":1})]);
}

Calendar.defaultProps = {"width":"96","height":"96","viewBox":"0 0 96 96","fill":"none"};

module.exports = Calendar;

Calendar.default = Calendar;
